var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title:
            _vm.$route.params.id != "0"
              ? _vm.isDisabled
                ? "套票详情"
                : "编辑套票"
              : "添加套票",
          backUrl: "/scenic-spot/packageticket-list",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c("div", { staticClass: "public-title" }, [
            _c("em"),
            _vm._v(" 景区套票信息 "),
          ]),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                width: "80%",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "套票名称：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入套票名称" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属景点：", prop: "scenicId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择所属景点",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.scenicId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "scenicId", $$v)
                        },
                        expression: "form.scenicId",
                      },
                    },
                    _vm._l(_vm.scenicAreaArr, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.scenicName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "平台分类：", prop: "categoryId" } },
                [
                  _c("el-cascader", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      options: _vm.merPlatProductClassify,
                      props: _vm.cascaderProps,
                      filterable: "",
                      clearable: "",
                      disabled: _vm.isDisabled,
                      "show-all-levels": false,
                    },
                    model: {
                      value: _vm.form.categoryId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "categoryId", $$v)
                      },
                      expression: "form.categoryId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签名：", prop: "tags" } },
                [
                  _c("keyword", {
                    staticClass: "from-ipt-width",
                    attrs: { labelarr: _vm.labelarr },
                    on: { getLabelarr: _vm.getLabelarr },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序：", prop: "sort" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 1 },
                            model: {
                              value: _vm.form.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sort", $$v)
                              },
                              expression: "form.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "缩略图", prop: "image" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox acea-row",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap("1")
                        },
                      },
                    },
                    [
                      _vm.form.image
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.form.image } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "请上传图片比例为1:1大小不超过300KB格式为png/jpg/jpeg/webp的文件"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详情图：", prop: "sliderImages" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _vm._l(_vm.form.sliderImages, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "pictrue",
                            attrs: { draggable: "true" },
                            on: {
                              dragstart: function ($event) {
                                return _vm.handleDragStart($event, item)
                              },
                              dragover: function ($event) {
                                $event.preventDefault()
                                return _vm.handleDragOver($event, item)
                              },
                              dragenter: function ($event) {
                                return _vm.handleDragEnter($event, item)
                              },
                              dragend: function ($event) {
                                return _vm.handleDragEnd($event, item)
                              },
                            },
                          },
                          [
                            _c("img", { attrs: { src: item } }),
                            _c("i", {
                              staticClass: "el-icon-error btndel",
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemove(index)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                      _vm.form.sliderImages.length < 10
                        ? _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("2")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "建议尺寸：800*800px，上传小于500kb的图片；最多可上传10张图片，拖动可调整顺序"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "主图视频：", prop: "video_link" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "from-ipt-width",
                          attrs: {
                            disabled: _vm.isDisabled,
                            size: "small",
                            placeholder: "请输入MP4格式的视频链接",
                          },
                          model: {
                            value: _vm.videoLink,
                            callback: function ($$v) {
                              _vm.videoLink = $$v
                            },
                            expression: "videoLink",
                          },
                        },
                        [
                          _c("input", {
                            ref: "refid",
                            staticStyle: { display: "none" },
                            attrs: { type: "file" },
                          }),
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                slot: "append",
                                action: "",
                                "http-request": _vm.handleUploadForm,
                                "before-upload": _vm.beforeAvatarUpload,
                                headers: _vm.myHeaders,
                                "show-file-list": false,
                                disabled: _vm.isDisabled,
                                multiple: "",
                              },
                              slot: "append",
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.videoLink ? "确认添加" : "上传视频"
                                      )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("请上传小于100M的视频"),
                  ]),
                  _vm.videoLink
                    ? _c("div", { staticClass: "iview-video-style" }, [
                        _c(
                          "video",
                          {
                            staticClass: "from-ipt-width",
                            staticStyle: {
                              height: "100% !important",
                              "border-radius": "10px",
                            },
                            attrs: { src: _vm.videoLink, controls: "controls" },
                          },
                          [_vm._v(" 您的浏览器不支持 video 标签。 ")]
                        ),
                        _c("div", { staticClass: "mark" }),
                        _c("i", {
                          staticClass: "el-icon-delete iconv",
                          on: { click: _vm.delVideo },
                        }),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "预定须知：", prop: "agreement" } },
                [
                  _c("Tinymce", {
                    key: 0,
                    model: {
                      value: _vm.form.agreement,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "agreement",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.agreement",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "适用时间段：", prop: "applicablePeriod" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.applicablePeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "applicablePeriod", $$v)
                        },
                        expression: "form.applicablePeriod",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "周一" } }),
                      _c("el-checkbox", { attrs: { label: "周二" } }),
                      _c("el-checkbox", { attrs: { label: "周三" } }),
                      _c("el-checkbox", { attrs: { label: "周四" } }),
                      _c("el-checkbox", { attrs: { label: "周五" } }),
                      _c("el-checkbox", { attrs: { label: "周六" } }),
                      _c("el-checkbox", { attrs: { label: "周日" } }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.selectAllWeeks()
                        },
                      },
                    },
                    [_vm._v("全选")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "public-title ml24" }, [
                _c("em"),
                _vm._v("套票优惠信息"),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "mb10",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = true
                    },
                  },
                },
                [_vm._v("添加套票")]
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tickets },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "票名", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.ticketName ||
                                    scope.row.name ||
                                    "未命名票"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "次数", width: "900" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "mini", type: "primary" } },
                                  [_vm._v("固定限制次数为1次")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#409EFF" },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteTicket(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "public-title ml24" }, [
                _c("em"),
                _vm._v("价格"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "销售价：", prop: "salesPrice" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0 },
                            model: {
                              value: _vm.form.salesPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "salesPrice", $$v)
                              },
                              expression: "form.salesPrice",
                            },
                          }),
                          _vm._v(" 元 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "市场价：", prop: "price" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0 },
                            model: {
                              value: _vm.form.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "price", $$v)
                              },
                              expression: "form.price",
                            },
                          }),
                          _vm._v(" 元 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "public-title ml24" }, [
                _c("em"),
                _vm._v("验证"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "套票有效期：", prop: "withinXDays" } },
                [
                  _vm._v(" 购买后"),
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    model: {
                      value: _vm.form.withinXDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "withinXDays", $$v)
                      },
                      expression: "form.withinXDays",
                    },
                  }),
                  _vm._v("天有效 "),
                ],
                1
              ),
              _c("div", { staticClass: "public-title ml24" }, [
                _c("em"),
                _vm._v("规则"),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: { label: "退款规则：", prop: "productReturnRuleIds" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        placeholder: "请选择退货规则",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.productReturnRuleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "productReturnRuleIds", $$v)
                        },
                        expression: "form.productReturnRuleIds",
                      },
                    },
                    _vm._l(_vm.backArr, function (item, index) {
                      return _c("el-option", {
                        key: index.id,
                        attrs: { value: item.id, label: item.typeName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款名称：", prop: "ext.returnKey" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入退款名称" },
                    model: {
                      value: _vm.form.ext.returnKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.ext, "returnKey", $$v)
                      },
                      expression: "form.ext.returnKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款说明：", prop: "ext.returnKeyValue" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入退款说明" },
                    model: {
                      value: _vm.form.ext.returnKeyValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.ext, "returnKeyValue", $$v)
                      },
                      expression: "form.ext.returnKeyValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "退款手续费名称：",
                    prop: "ext.commissionKey",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入退款手续费名称" },
                    model: {
                      value: _vm.form.ext.commissionKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.ext, "commissionKey", $$v)
                      },
                      expression: "form.ext.commissionKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "退款手续费：", prop: "ext.commissionValue" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入退款手续费" },
                    model: {
                      value: _vm.form.ext.commissionValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.ext, "commissionValue", $$v)
                      },
                      expression: "form.ext.commissionValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "限购规则：", prop: "limitBuyRuleIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.limitBuyRuleIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "limitBuyRuleIds", $$v)
                        },
                        expression: "form.limitBuyRuleIds",
                      },
                    },
                    _vm._l(_vm.limitArr, function (item, index) {
                      return _c("el-option", {
                        key: index.id,
                        attrs: { value: item.id, label: item.typeName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "限购规则描述：", prop: "ext.limitBuyDesc" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入限购规则描述" },
                    model: {
                      value: _vm.form.ext.limitBuyDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.ext, "limitBuyDesc", $$v)
                      },
                      expression: "form.ext.limitBuyDesc",
                    },
                  }),
                ],
                1
              ),
              _vm.checkPermi(["merchant:product:update"])
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDisabled,
                          expression: "!isDisabled",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formValidate")
                        },
                      },
                    },
                    [_vm._v(" 立即提交 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请选择门票",
            "destroy-on-close": "",
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticClass: "yearFormValidate",
              attrs: { "label-width": "105px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门票:", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        clearable: "",
                        placeholder: "请选择门票",
                        filterable: "",
                      },
                      model: {
                        value: _vm.yearFormValidate,
                        callback: function ($$v) {
                          _vm.yearFormValidate = $$v
                        },
                        expression: "yearFormValidate",
                      },
                    },
                    _vm._l(_vm.returnArr, function (item, index) {
                      return _c("el-option", {
                        key: index.id,
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "submission",
                  attrs: { type: "primary", loading: _vm.loadingBtn },
                  on: { click: _vm.dialogHandleSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }